import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"h-alt-hf d-flex flex-column align-items-center justify-content-center text-center\"><h1 class=\"page-error color-fusion-500\"> ERROR <span class=\"text-gradient\">404</span><small class=\"fw-500\"> アクセスしたページは存在しません</small></h1><h3 class=\"fw-500 mb-5\">管理者に問い合わせてください</h3></div>", 1)
  ])))
}